import Styled from 'styled-components';

export const Container = Styled.div`
display:flex;
flex-direction:row;
justify-content:center;
flex: 1;
min-width: 0;
`;

export const Text = Styled.div`
padding-left:9px;
flex: 1;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
`;
